import { useCallback } from 'react'

import { useMetadata } from '@scoir/tracking'

import { getUnauthedFallbackUrl } from 'common/api'
import { getParams } from 'common/click-tracking-params'
import window from 'common/window'

export const useRedirectToSignIn = () => {
  const [getMetadata] = useMetadata()
  const { RedirectClickLabel, RedirectClickLocation, scid } = getMetadata() as any
  const queryString = getParams(RedirectClickLabel, RedirectClickLocation, scid)

  const redirectToSignIn = useCallback(() => {
    window.location.href = `${window.location.origin}${getUnauthedFallbackUrl()}?${queryString}`
  }, [queryString])
  return redirectToSignIn
}
